import { useMemo } from 'react';
import { useMapped$ } from '@/js/libs/observable';
export function useMappedRequest(request, mapper) {
    const mappedData$ = useMapped$((ctx) => {
        const resp = ctx.spy(request.data$);
        if (resp?.data) {
            return {
                ...resp,
                data: mapper(resp.data),
            };
        }
        return resp;
    });
    // @ts-expect-error - I am ok with fact that 'X' could be instantiated with an arbitrary type which could be unrelated to 'unknown' =)
    return useMemo(() => ({
        ...request,
        data$: mappedData$,
    }), [mappedData$, request]);
}
